import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { rbacApi } from '../../Api/superadminApicall';

// Async thunks
export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ page = 1, pageSize = 10, search = '', status = 'active', roleId = '' }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.users.list(page, pageSize, search, status, roleId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch users');
    }
  }
);

export const assignRoleToUser = createAsyncThunk(
  'users/assignRole',
  async ({ userId, roleId }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.users.assignRole(userId, roleId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to assign role');
    }
  }
);

export const createUser = createAsyncThunk(
  'users/createUser',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await rbacApi.users.create(userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.response?.data?.error || 'Failed to create user'
      );
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ userId, userData }, { rejectWithValue }) => {
    try {
      const response = await rbacApi.users.update(userId, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.response?.data?.error || 'Failed to update user'
      );
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState: {
    userData: {
      users: [],
      total: 0,
      page: 1,
      page_size: 10,
      total_pages: 0
    },
    loading: false,
    error: null,
    assigningRole: false,
    roleAssignmentError: null,
    creatingUser: false,
    updatingUser: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.userData = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(assignRoleToUser.pending, (state) => {
        state.assigningRole = true;
        state.roleAssignmentError = null;
      })
      .addCase(assignRoleToUser.fulfilled, (state, action) => {
        state.assigningRole = false;
        state.roleAssignmentError = null;
      })
      .addCase(assignRoleToUser.rejected, (state, action) => {
        state.assigningRole = false;
        state.roleAssignmentError = action.payload;
      })
      .addCase(createUser.pending, (state) => {
        state.creatingUser = true;
        state.error = null;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.creatingUser = false;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.creatingUser = false;
        state.error = action.payload;
      })
      .addCase(updateUser.pending, (state) => {
        state.updatingUser = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.updatingUser = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.updatingUser = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSuccess, resetState } = userSlice.actions;
export default userSlice.reducer;
